
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, reactive, onMounted } from 'vue'
import {
  PullRefresh,
  DatetimePicker,
  Popup,
  Icon,
  CheckboxGroup,
  Checkbox,
  Toast,
  List,
} from 'vant'
import { dateFormat } from '@/utils/dateFormatter'
import { getDeviceLogs } from '@/apis/service'
import { useStore } from 'vuex'
export default defineComponent({
  name: 'ServiceDetail',
  components: {
    AppHeader,
    vanDatetimePicker: DatetimePicker,
    vanIcon: Icon,
    vanPullRefresh: PullRefresh,
    vanPopup: Popup,
    vanCheckboxGroup: CheckboxGroup,
    vanCheckbox: Checkbox,
    vanList: List,
  },
  setup() {
    const currentDate = ref(new Date()) // 日期选择框的时间
    const indexSelectDate = ref(new Date()) // 加载日志的时间
    const minDate = ref(new Date(2007, 0, 1)) // 日期选择框最小可选时间
    const showPopop = ref(false) // 是否展示弹窗
    const flightChecked = ref([]) // 已选日志
    const flightList = ref([]) // 日志列表
    const refreshLoading = ref(false) // 下拉刷新
    const listOnloading = ref(false) // 列表加载按钮
    const listOnFinished = ref(false) // 是否加载完毕数据
    const store = useStore()
    const indexSelectLog = computed(() => {
      return store.getters.getAppealSelectLog
    })
    const { proxy } = getCurrentInstance()
    const paginaData = reactive({
      page: 1,
      size: 10,
    })
    // 打开弹窗
    const handleOpenPopop = () => {
      showPopop.value = true
    }
    // 关闭弹窗
    const handleCancel = () => {
      showPopop.value = false
    }
    // 确定弹窗
    const handleConfirm = async () => {
      indexSelectDate.value = currentDate.value
      showPopop.value = false
      paginaData.page = 1
      await initLog()
      paginaData.page++
    }
    // 时间格式化
    const handleDateFormatter = (date: Date) => {
      return dateFormat('YYYY-mm-dd', date)
    }
    // 下拉刷新
    const onRefresh = async () => {
      paginaData.page = 1
      await initLog()
      paginaData.page++
      refreshLoading.value = false
    }
    // 加载日志
    const initLog = async () => {
      let start_time = new Date(
        indexSelectDate.value.getFullYear(),
        indexSelectDate.value.getMonth(),
        indexSelectDate.value.getDate()
      ).getTime()
      let param = {
        sn: proxy.$route.params.sn,
        start_time: start_time / 1000,
        end_time: start_time / 1000 + 86399,
        pid: paginaData.page,
        psize: paginaData.size,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getDeviceLogs(param)
        toast.clear()
        if (paginaData.page == 1) {
          flightList.value = result || []
        }
        if (paginaData.page > 1) {
          for (let i = 0; i < result.length; i++) {
            result[i].workTime = `${dateFormat(
              'HH:MM:SS',
              new Date(Number(result[i].startAt * 1000))
            )} - ${dateFormat('HH:MM:SS', new Date(Number(result[i].endAt * 1000)))}`
            flightList.value.push(result[i])
          }
        }
        if (result.length < paginaData.size) {
          listOnFinished.value = true
        }
        listOnloading.value = false
      } catch (error: any) {
        let message = error && error.message ? error.message : '加载日志数据失败'
        toast.clear()
        Toast(message)
      }
    }
    const listOnLoadData = () => {
      initLog()
      paginaData.page++
    }
    const handlerightConfirm = () => {
      if (flightChecked.value.length == 0) {
        Toast('请选择日志')
        return
      }
      let indexLog = JSON.parse(JSON.stringify(indexSelectLog.value))
      if (indexLog.length == 0) {
        indexLog = flightChecked.value
      } else {
        let findSame = false
        for (let j = 0; j < flightChecked.value.length; j++) {
          findSame = false
          for (let i = 0; i < indexLog.length; i++) {
            if (indexLog[i].guid == flightChecked.value[j].guid) {
              findSame = true
              break
            }
          }
          if (!findSame) {
            indexLog.push(flightChecked.value[j])
          }
        }
      }
      store.commit('setAppealSelectLog', indexLog)
      proxy.$router.replace({
        path: `/serviceappeal/${proxy.$route.params.sn}/${proxy.$route.params.guid}/${proxy.$route.params.type}`,
      })
    }
    // 点击返回
    const handleBackPage = () => {
      proxy.$router.replace({
        path: `/serviceappeal/${proxy.$route.params.sn}/${proxy.$route.params.guid}/${proxy.$route.params.type}`,
      })
    }
    // 初始化数据
    onMounted(() => {
      initLog()
      paginaData.page++
    })
    return {
      currentDate,
      minDate,
      indexSelectDate,
      showPopop,
      flightList,
      flightChecked,
      refreshLoading,
      listOnloading,
      listOnFinished,
      isMiniProgram: store.getters.isMiniProgram,
      pagePaddingTop: store.getters.pagePaddingTop,
      handleOpenPopop,
      handleCancel,
      handleConfirm,
      handleDateFormatter,
      onRefresh,
      listOnLoadData,
      handlerightConfirm,
      handleBackPage,
    }
  },
})
